import React from 'react';
import Image, { Props as ImageProps } from '../../image/image';
import './lazy.scss';

export default function Lazy(props: Props) {
    const { src, ...otherProps } = props;
    return <Image imageClasses="lazyload" datasrc={src} {...otherProps} />;
}

Lazy.defaultProps = {
    alt: undefined,
    className: undefined,
    src: undefined,
    width: undefined,
    height: undefined,
};

type Props = Pick<ImageProps, 'alt' | 'className' | 'height' | 'src' | 'width'>;
